import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EnvironmentPlatform } from 'src/environments/models/environment-platform';
import { EngineService } from '../engine/engine.service';
import { EventsEnum } from '../engine/models/events.enum';

export type CopyClipboardType = 'text' | 'url' | 'embed' | 'image';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {  

  constructor(private engineService: EngineService) { }

  getClipboardAPISupport(): boolean {
    return 'clipboard' in navigator;
  }

  getClipboardAPI(): any {
    return navigator['clipboard'];
  }

  copyToClipboard(val: string, type: CopyClipboardType): Observable<boolean> {
    // native hook to handle copying
    if (environment.native === true || environment.platform === EnvironmentPlatform.SDK) {
      return new Observable<boolean>((observer) => {
        this.engineService.fireEvent(EventsEnum.NativeShare, {
          type: type,
          value: val
        });

        observer.next(true);
        observer.complete();
      });
    }

    if (this.getClipboardAPISupport()) {
      const clipboardAPI = this.getClipboardAPI();
      return new Observable<boolean>((observer) => {
        clipboardAPI.writeText(val)
          .then(() => {
            observer.next(true);
            observer.complete();
          })
          .catch((e) => {
            observer.next(false);
            observer.complete();
          });
      });
    } else { // async copy unsupported
      return of(false);
    }
  }

  copyInputFieldValue(input: HTMLInputElement | HTMLTextAreaElement): boolean {
    input.select();
    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (err) {
      copied = false;
    }
    return copied;
  }
}
